<main @fade>
  <content>
    <p class="intro">
      Michelle Gomes Interiors is a creative Interior Design studio in Stafford,
      Midlands, United Kingdom. We collaborate with clients to create their
      dream residential and commercial spaces fulfilling all their requirements
      and aspirations. The results are beautiful functional spaces that improve
      the quality of lives of the people that enjoy the spaces and reflect their
      personalities.
    </p>
    <section class="about-me">
      <div class="portrait-container">
        <img src="../../../assets/images/portrait.jpeg" alt="Portrait" />
      </div>
      <div class="about-content">
        <p>
          Michelle is an experienced interior designer who graduated with
          distinction from the British Academy of Interior Design and is an
          Associate of the British Institute of Interior Design. She is
          passionate about Interiors, Interior Architecture, Furniture and
          Design.
        </p>
        <p>
          Her expertise has been gained by delivering residential and commercial
          projects utilising her network of skilled suppliers in the industry;
          and previously working for an award-winning Interior Designer in
          London.
        </p>

        <div class="border"></div>

        <div class="contact-links">
          <h2>Contact</h2>
          <div>
            <span>New Business: </span>
            <a [routerLink]="['/enquiry']">Please submit my enquiry form.</a>
          </div>

          <div>
            <span>Other: </span>
            <a href="mailto:hello@michellegomesinteriors.com">
              hello@michellegomesinteriors.com
            </a>
          </div>
        </div>
      </div>
    </section>
  </content>
</main>
